import React, { useLayoutEffect, useContext, useState } from 'react';
import { Process } from '../../components/process/process';
import { useUFormRequests } from './uform-hook';
import { ProcessForm } from './uform-types';
import { TranslationKeys } from '../../enums';
import { UFormProvider, useUFormContext } from './uform-context';
import { usePrompts, PromptContext } from '@eas/common-web';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { useHistory } from 'react-router-dom';

const ROB_WARNING_KEY = 'ROB_WARNING_KEY';

export function UFormNew() {
  const [confirmed, setConfirmed] = useState(false);
  const { goBack } = useHistory();
  usePrompts(
    [
      {
        key: ROB_WARNING_KEY,
        dialogTitle: 'Upozornění',
        dialogText:
          'Pro předvyplnění údajů o osobě činící podání dojde k načtení z Registru obyvatel.',
        dialogDisableBackdrop: true,
        dialogShowConfirm: false,
        dialogShowClose: false,

        FormFields: function Body({ onCancel }) {
          return (
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                width: '100%',
              }}
            >
              <ButtonGroup>
                <Button
                  color="primary"
                  key={1}
                  onClick={() => {
                    setConfirmed(true);
                    onCancel?.();
                  }}
                >
                  ANO, SOUHLASÍM
                </Button>
                <Button
                  key={1}
                  onClick={() => {
                    setConfirmed(false);
                    onCancel?.();
                    goBack();
                  }}
                >
                  ZRUŠIT
                </Button>
              </ButtonGroup>
            </div>
          );
        },
      },
    ],
    []
  );

  return <UFormWithPrompt confirmed={confirmed} />;
}

function UFormWithPrompt({ confirmed = false }: { confirmed?: boolean }) {
  const { testPrompt } = useContext(PromptContext);

  useLayoutEffect(() => {
    setTimeout(() => {
      if (!confirmed) {
        testPrompt({
          key: ROB_WARNING_KEY,
          submitCallback: () => {},
        });
      }
    });
  }, [testPrompt, confirmed]);

  if (confirmed) {
    return (
      <UFormProvider>
        <UFormNewContent />
      </UFormProvider>
    );
  }

  return null;
}

function UFormNewContent() {
  const { profile } = useUFormContext();
  const { steps } = useUFormRequests(profile!);

  return (
    <Process<ProcessForm>
      steps={steps}
      title="Podání jednoduchého formuláře"
      translationKey={TranslationKeys.UFORM_REQUEST}
    />
  );
}
